// TODO: Move items from management.js to this file.
import { company_name } from "@/i18n/variables";

const page = {
	password_tile: {
		credentials_saved_button: "I have saved the data.",
		description:
			"The login details for your VPS will be stored in the password vault for <strong>30 days</strong>. Save these details in your own password manager.",
		description_completed: `You have saved the login details from the password vault in your password manager. If you have not saved your password, please contact ${company_name}.`,
		password_vault_button: "To password vault",
		title: "Login details",
	},
};

const manage = {
	page: page,
};

export default manage;
